import { connect } from 'react-redux';

import OtherFilters from './OtherFilters';
import { trackFilterClickAdditionalCriteria } from '../../../../actions';

const mapDispatchToProps = {
    trackFilterClickAdditionalCriteria,
};

export default connect(undefined, mapDispatchToProps)(OtherFilters);
